import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { InputDatepickerComponent } from '@ar2/common';
import { ViewChild } from '@angular/core';
/**
 * 日付入力フィールド
 *【ラベル内容:labelContent:string】
 *【入力日付:inputDate:string】
 *【日付フォーマット:dateFormat:string】
 *【表示条件:visible:boolean】
 *【フォームコントロール名:formControl:FormControl】
 *【非活性:disabled:boolean】
 *【レンジ開始日:minFrom:string】
 *【レンジ終了日:maxTo:string】
 *【フォーカスインイベント:enableFocusIn:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-input-datepicker-field',
  templateUrl: './input-datepicker-field.html',
  styles: [`
    
  `]
})
export class InputDatepickerField extends BaseWidget {
  /**
   * 入力日付の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 入力日付に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 日付フォーマット
   */
  @Input() dateFormat:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * フォームコントロール名
   */
  @Input() formControl:FormControl

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * レンジ開始日
   */
  @Input() minFrom:string

  /**
   * レンジ終了日
   */
  @Input() maxTo:string

  /**
   * フォーカスインイベント
   */
  @Input() enableFocusIn:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * 表示用日付
   */
  private displayDate:string
  /**
   * get datepicker
   */
  @ViewChild('datepicker')
  public inputDatepicker: InputDatepickerComponent;
  /**
   * 入力日付
   */
  private _inputDate:string
  @Input()
  set inputDate(target:string) {
    if (this._inputDate !== target) {
      this._inputDate = target
      if (this.inputDatepicker && !!target) {
        this.displayDate = moment(moment(target).toDate())
                            .format(this.inputDatepicker.currentDateFormatCulture);
      } else {
        this.displayDate = target
      }
    }
  }
  get inputDate():string {
    return this._inputDate
  }
  /**
   * format of ymd
   */
  private YMD = 'YYYY/MM/DD';
  /**
   * format of ym
   */
  private YM = 'YYYY/MM';
  /**
   * format of md
   */
  private MD = 'MM/DD';
  /**
   * 入力日付を取得する
   * @param data
   */
  public getSelectedDate(data) {
    let inputDateBefore = this.inputDate;
    const d:Date = data.date;
    const formatter = this.dateFormat === 'ymd' ? this.YMD
                    : this.dateFormat === 'ym' ? this.YM
                    : this.dateFormat === 'md' ? this.MD
                    : this.YMD
    this._inputDate = d ? moment(d).format(formatter) : '';
    this.displayDate = d ? moment(d).format(this.inputDatepicker.currentDateFormatCulture) : '';
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this._inputDate,
      {id:this.id, type:data.event, source:new Event(data.event)},
      `update by ${this.id}`,
    ))
    if (inputDateBefore !== this._inputDate) {
      this.on("change");
    }
  }
  ngOnInit() {
    if(!this.formControl) {
      this.formControl = new FormControl('');
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/input-datepicker-field/input-datepicker-field.component.ts